import { ICustomError } from '@/bundles/Http/interfaces/ICustomError';

export const REQUEST_CANCELLED_STATUS = -1; // should be less than 0, so will not be added to notifications
export const REQUEST_CANCELLED_MESSAGE = 'Request cancelled';

export default class ErrorMapper {
  /**
   * The v1 API answers `ctx.throw(status, message)` with the bare text, the v2 API with
   * `{ message }` or `{ error }`, and a v2 validation failure can send an array of messages.
   * Falls back to axios's own `error.message` when the body carries nothing usable.
   */
  getErrorMessage (error: any): Error {
    const data = error?.response?.data;
    let message = error.message;

    if (typeof data === 'string' && data.trim()) {
      message = data;
    } else if (data && typeof data === 'object') {
      if (Array.isArray(data.message)) {
        message = data.message.filter(Boolean).join('. ') || message;
      } else {
        message = data.message || data.error || message;
      }
    }

    return new Error(message);
  }
  mapToCodeModel (error: any): ICustomError {
    const isCustomError = this.getErrorMessage(error).message === REQUEST_CANCELLED_MESSAGE;
    const defaultStatus = isCustomError ? REQUEST_CANCELLED_STATUS : 400;

    const parsedError = {
      message: this.getErrorMessage(error).message,
      title: error?.response?.statusText || 'Error',
      status: error?.response?.status || defaultStatus,
      url: error?.request?.responseURL
    };

    throw parsedError;
  }
}
